import { render, staticRenderFns } from "./Q6.vue?vue&type=template&id=744f717a&scoped=true&"
import script from "./Q6.vue?vue&type=script&lang=js&"
export * from "./Q6.vue?vue&type=script&lang=js&"
import style0 from "./Q6.vue?vue&type=style&index=0&id=744f717a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f717a",
  null
  
)

export default component.exports